import { render } from "./LaravelVueDatatables.vue?vue&type=template&id=51639cc2"
import script from "./LaravelVueDatatables.vue?vue&type=script&lang=js"
export * from "./LaravelVueDatatables.vue?vue&type=script&lang=js"

import "./LaravelVueDatatables.vue?vue&type=style&index=0&id=51639cc2&lang=css"

import exportComponent from "/deploy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__